<template>
  <div class="translation-setting">
    <h3 class="text-xl font-bold text-neutral-900">{{ $t('Translations') }}</h3>
    <p class="text-neutral-600 mt-1 mb-6">{{ $t('Configure the language settings for your project.') }}</p>
    <h4 class="font-semibold text-neutral-900">{{ $t('Language') }}</h4>
    <p class="text-neutral-600 mt-1 mb-2">
      {{ $t('Select the language you want your project to be displayed in.') }}
    </p>
    <div class="max-w-md">
      <select
        v-model="locale"
        class="select w-full"
      >
        <option value="" disabled>{{ $t('Select Language') }}</option>
        <option
          v-for="option in options"
          :key="option.id"
          :value="option.id"
        >
          {{ option.text }}
        </option>
      </select>
    </div>
    <h4 class="font-semibold text-neutral-900 mt-6">{{ $t('Auto-detect visitor language') }}</h4>
    <p class="text-neutral-600 mt-1 mb-2">
      {{ $t('Automatically show FeedBear in each visitor\'s browser language when available. Falls back to the language above.') }}
    </p>
    <div class="toggle-wrapper mt-1">
      <div class="button--toggle">
        <input
          id="detect_visitor_language"
          type="checkbox"
          class="checkbox"
          v-model="detectVisitorLanguage"
        />
        <div class="knobs"></div>
        <div class="layer"></div>
      </div>
      <span>
        <strong v-if="detectVisitorLanguage">{{ $t('On') }}</strong>
        <strong v-else>{{ $t('Off') }}</strong>
      </span>
    </div>
    <button
      class="btn-main mt-6"
      @click="changeLocale()"
    >
      {{ $t('Save') }}
    </button>
    <p class="text-neutral-600 mt-4 mb-4">
      {{ $t('Certain elements of your project are customizable. You will want to manually update those to the selected language. Here is a list of the areas you will want to update:') }}
    </p>
    <div class="pl-5">
      <ul class="font-normal text-project-500 mt-4 list-disc">
        <li v-for="board in boards" :key="board.name">
          <a :href="board.url" target="_blank">{{ board.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "translation_setting",
  data() {
    return {
      locale: "",
      detectVisitorLanguage: false,
      // Populated from GET /locale_settings — the list of supported locales
      // lives in Ruby (Locales::NAMES), not here.
      options: [],
      boards: [],
    };
  },
  created() {
    Rails.ajax({
      url: "/locale_settings",
      type: "GET",
      beforeSend: function () {
        return true;
      },
      success: (data) => {
        this.locale = data.current_locale;
        this.detectVisitorLanguage = data.detect_visitor_language;
        this.options = data.locale_options;
        this.boards = data.boards;
      },
      error: (data, status) => {
        this.error = data;
      },
    });
  },
  methods: {
    changeLocale() {
      let data = new FormData();
      data.append("project_locale", this.locale);
      data.append("detect_visitor_language", this.detectVisitorLanguage);
      Rails.ajax({
        url: "/locale_settings",
        type: "POST",
        data: data,
        dataType: "json",
        processData: true,
        beforeSend: function () {
          return true;
        },
        success: () => {
          this.$notify({ group: 'success', text: this.$t('Changes saved') });
        },
        error: () => {
          this.$notify({ group: 'alert', text: this.$t('Something went wrong! You might want to try again in a few minutes') });
        },
      });
    },
  },
};
</script>

<style scoped>
.toggle-wrapper {
  display: flex;
  align-items: center;
}

.button--toggle {
  position: relative;
  width: 74px;
  height: 36px;
  overflow: hidden;
  margin-right: 0.5rem;
}

.button--toggle,
.button--toggle .layer {
  border-radius: 100px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #f5f5f5;
  transition: 0.3s ease all;
  z-index: 1;
  border: 1px solid gainsboro;
}

.button--toggle .knobs:before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 28px;
  height: 28px;
  background-color: #d2d2d2;
  border-radius: 50%;
  transition: 0.3s ease all, left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
}

.button--toggle .checkbox:active + .knobs:before {
  width: 46px;
  border-radius: 100px;
}

.button--toggle .checkbox:checked:active + .knobs:before {
  margin-left: -26px;
}

.button--toggle .checkbox:checked + .knobs:before {
  content: "";
  left: 42px;
  background-color: #3bd087;
}

.button--toggle .checkbox:checked ~ .layer {
  background-color: #d1f0e1;
  border-color: #a3e6c6;
}
</style>
